/* PK custom cart drawer + swatch slider. Vervangt UpCart en SwatchKing. */
(function () {
  'use strict';
  var CFG = window.PkCartCfg || {};
  var ROOT = (CFG.root || '/').replace(/\/?$/, '/');
  var SEC = 'pk-cart';
  var drawer = function () { return document.getElementById('PkCart'); };
  var lastFocus = null;
  var busy = false;

  function isOpen() { return document.documentElement.classList.contains('pk-open'); }
  function open() {
    var d = drawer(); if (!d) return;
    lastFocus = document.activeElement;
    document.documentElement.classList.add('pk-open');
    setTimeout(function () { var c = d.querySelector('[data-pk-close]') || d; try { c.focus({ preventScroll: true }); } catch (e) {} }, 50);
  }
  function close() {
    document.documentElement.classList.remove('pk-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function apply(html) {
    var d = drawer(); if (!d || !html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('#PkCartInner');
    var cur = d.querySelector('#PkCartInner');
    if (fresh && cur) { cur.replaceWith(fresh); }
    var count = fresh ? parseInt(fresh.getAttribute('data-count') || '0', 10) : 0;
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', count > 0);
    });
    document.querySelectorAll('[data-cart-count]').forEach(function (b) { b.textContent = count; });
    document.dispatchEvent(new CustomEvent('pk:cart:updated', { detail: { count: count } }));
  }

  function setBusy(on) { busy = on; var d = drawer(); if (d) d.classList.toggle('is-busy', on); }

  function refresh() {
    return fetch(ROOT + '?sections=' + SEC, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { apply(j[SEC]); });
  }

  function showAtcError(form, msg) {
    var el = form.querySelector('.pk-atc-err');
    if (!el) {
      el = document.createElement('span'); el.className = 'pk-atc-err'; el.setAttribute('role', 'alert');
      var btn = form.querySelector('[type=submit],[name=add]');
      (btn && btn.parentNode ? btn.parentNode : form).appendChild(el);
    }
    el.textContent = msg; el.hidden = false;
    setTimeout(function () { el.hidden = true; }, 6000);
  }

  function addFromForm(form, submitter) {
    var btn = submitter || form.querySelector('[type=submit],[name=add]');
    if (btn) { if (btn.getAttribute('aria-busy') === 'true') return; btn.setAttribute('aria-busy', 'true'); btn.classList.add('btn--loading'); }
    var fd = new FormData(form);
    if (!fd.get('id')) {
      var sel = form.querySelector('[name=id]'); if (sel) fd.set('id', sel.value);
    }
    if (!fd.get('quantity')) fd.set('quantity', '1');
    fd.append('sections', SEC);
    fd.append('sections_url', location.pathname);
    return fetch(ROOT + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { showAtcError(form, res.j.description || res.j.message || 'This item could not be added.'); return; }
        if (res.j.sections && res.j.sections[SEC]) apply(res.j.sections[SEC]); else return refresh().then(open);
        open();
      })
      .catch(function () { (window.__pkNativeSubmit || HTMLFormElement.prototype.submit).call(form); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('btn--loading'); } });
  }

  function changeLine(li, qty) {
    if (busy) return;
    setBusy(true);
    var key = li.getAttribute('data-key');
    fetch(ROOT + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: SEC, sections_url: location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var e = li.querySelector('[data-pk-err]');
          if (e) { e.textContent = res.j.description || res.j.message || 'Could not update quantity.'; e.hidden = false; }
          return;
        }
        if (res.j.sections && res.j.sections[SEC]) apply(res.j.sections[SEC]); else return refresh();
      })
      .catch(function () { return refresh(); })
      .finally(function () { setBusy(false); });
  }

  var onCartPage = function () { return /\/cart\/?$/.test(location.pathname); };

  // Add to cart: onderschep elk product-formulier
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addFromForm(f, e.submitter);
  }, true);

  // Sticky add-to-cart van Vitals: zelf toevoegen en de slide cart openen i.p.v. naar /cart
  function stickyVariantId(root) {
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    var vs = (meta && meta.variants) || [];
    if (root && vs.length) {
      var titles = {};
      vs.forEach(function (v) { if (v.public_title) titles[v.public_title.trim()] = v.id; });
      var box = root.getBoundingClientRect();
      var leaves = root.querySelectorAll('*');
      for (var i = 0; i < leaves.length; i++) {
        var el = leaves[i];
        if (el.children.length || !el.getClientRects().length) continue;
        var r = el.getBoundingClientRect(), cy = r.top + r.height / 2;
        if (cy < box.top || cy > box.bottom) continue;
        var t = (el.textContent || '').trim();
        if (titles[t]) return titles[t];
      }
      if (vs.length === 1) return vs[0].id;
    }
    var main = document.querySelector('.product-single__meta form[action*="/cart/add"] [name=id]') || document.querySelector('form[action*="/cart/add"] [name=id]');
    return main ? main.value : null;
  }
  function stickyAdd(e) {
    var b = e.target && e.target.closest && e.target.closest('#bundle-sticky_submit, .Vtl-StickyAddToCart__AddToCartButton');
    if (!b || onCartPage()) return;
    e.stopImmediatePropagation();
    if (e.type !== 'click') return;
    e.preventDefault();
    var id = stickyVariantId(b.closest('.Vtl-StickyAddToCart'));
    if (!id) return;
    var f = document.createElement('form');
    f.setAttribute('action', ROOT + 'cart/add');
    var i1 = document.createElement('input'); i1.name = 'id'; i1.value = id; f.appendChild(i1);
    var i2 = document.createElement('input'); i2.name = 'quantity'; i2.value = '1'; f.appendChild(i2);
    addFromForm(f, b);
  }
  ['pointerdown', 'mousedown', 'touchstart', 'touchend', 'mouseup', 'pointerup', 'click'].forEach(function (t) {
    document.addEventListener(t, stickyAdd, { capture: true, passive: false });
  });

  // Cart-icoon en cart-links openen de drawer
  document.addEventListener('click', function (e) {
    var t = e.target;
    var d = drawer();
    if (d && d.contains(t)) {
      var q = t.closest('[data-pk-qty]');
      if (q) { e.preventDefault(); changeLine(q.closest('.pk-line'), parseInt(q.getAttribute('data-pk-qty'), 10)); return; }
      if (t.closest('[data-pk-close]')) { e.preventDefault(); close(); return; }
      return;
    }
    if (t.closest && t.closest('.pk-backdrop')) { close(); return; }
    var a = t.closest && t.closest('a[href]');
    if (a && !onCartPage() && !e.metaKey && !e.ctrlKey) {
      var href = a.getAttribute('href') || '';
      var path = href.split('?')[0].replace(/^https?:\/\/[^/]+/, '');
      if (/\/cart\/?$/.test(path) || a.classList.contains('js-drawer-open-cart')) {
        e.preventDefault(); e.stopImmediatePropagation();
        open(); refresh();
      }
    }
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });

  // Andere scripts (bijv. sticky add-to-cart) kunnen de drawer openen
  window.PkCart = { open: function () { open(); refresh(); }, close: close, refresh: refresh, add: function (f, s) { return addFromForm(f, s); } };
  (window.__pkQ || []).splice(0).forEach(function (it) { addFromForm(it[0], it[1]); });
  document.addEventListener('cart:open', function () { window.PkCart.open(); });
  document.addEventListener('ajaxProduct:added', function () { refresh().then(open); });

  // Herstel na terug-navigatie (bfcache)
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });


  /* ---------- Size chart popup + knop naast "Size" ---------- */
  function initSizeCharts(scope) {
    (scope || document).querySelectorAll('[data-pk-sc]').forEach(function (blk) {
      if (blk.__pk) return; blk.__pk = true;
      var form = blk.closest('.product-single__meta, .product-block-list, form, .page-content') || document;
      var wrap = null;
      (form.querySelectorAll ? form : document).querySelectorAll('.variant-wrapper').forEach(function (w) {
        var fs = w.querySelector('.variant-input-wrap'); var h = fs ? (fs.getAttribute('data-handle') || fs.getAttribute('name') || '') : '';
        if (!wrap && /size|maat|taille/i.test(h)) wrap = w;
      });
      if (wrap) {
        var lbl = wrap.querySelector('.variant__label');
        if (lbl) { var row = document.createElement('div'); row.className = 'pk-sc-row'; lbl.parentNode.insertBefore(row, lbl); row.appendChild(lbl); row.appendChild(blk); }
      }
    });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-pk-sc-open]');
    if (o) { e.preventDefault(); var d = document.getElementById(o.getAttribute('aria-controls')); if (d && d.showModal) { d.showModal(); } return; }
    var c = e.target.closest && e.target.closest('[data-pk-sc-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('pk-sc')) { e.target.close(); }
  });

  /* ---------- Swatch slider ---------- */
  function initSwatches(scope) {
    (scope || document).querySelectorAll('.variant-input-wrap.pk-sw').forEach(function (wrap) {
      if (wrap.__pk) return; wrap.__pk = true;
      var box = document.createElement('div'); box.className = 'pk-sw-wrap';
      wrap.parentNode.insertBefore(box, wrap); box.appendChild(wrap);
      var mk = function (dir) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'pk-sw-nav pk-sw-nav--' + dir;
        b.setAttribute('aria-label', dir === 'r' ? 'Scroll right' : 'Scroll left');
        b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M8.6 16.6L13.2 12 8.6 7.4 10 6l6 6-6 6z"/></svg>';
        b.addEventListener('click', function () { wrap.scrollBy({ left: (dir === 'r' ? 1 : -1) * Math.max(120, wrap.clientWidth * 0.6), behavior: 'smooth' }); });
        box.appendChild(b);
      };
      mk('l'); mk('r');
      var upd = function () {
        box.classList.toggle('can-l', wrap.scrollLeft > 4);
        var ovf = wrap.scrollWidth > wrap.clientWidth + 4;
        wrap.classList.toggle('is-ovf', ovf);
        box.classList.toggle('can-r', ovf && wrap.scrollLeft + wrap.clientWidth < wrap.scrollWidth - 4);
      };
      wrap.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd(); setTimeout(upd, 400);
      // geselecteerde kleur in beeld
      var chk = wrap.querySelector('input:checked');
      if (chk && chk.parentNode && chk.parentNode.offsetLeft > wrap.clientWidth) wrap.scrollLeft = chk.parentNode.offsetLeft - 8;
    });
  }
  if (document.readyState !== 'loading') { initSwatches(); initSizeCharts(); } else document.addEventListener('DOMContentLoaded', function () { initSwatches(); initSizeCharts(); });
  document.addEventListener('quickshop:opened', function () { initSwatches(); });
  var pkT = null;
  new MutationObserver(function () { if (pkT) return; pkT = setTimeout(function () { pkT = null; initSwatches(); initSizeCharts(); }, 250); }).observe(document.documentElement, { childList: true, subtree: true });
})();
